<div class="container mt-2 pl-0">
    <div class="col-md-12 col-6 mb-lg-5 align-self-end align-self-lg-center mb-5 mb-lg-0 m">
        <a [routerLink]="['/','admin', 'packs']" class="mb-lg-4 d-flex flex-row align-items-center text-decoration-none">
            <img src="../assets/images/body/icons/volver.svg" class="pe-2" alt="">
            <h4 class="mb-0" style="color:#00008B"> Volver</h4>
        </a>
    </div>
    <form [formGroup]="form1" (ngSubmit)="onSubmit2()" class="login mt-5 z-index-top">
        <div class="row">
            <div class="col-lg-8 col-xxl-8 z-index--top">
                <div class="d-flex align-items-baseline flex-row">
                    <div class="form-control p-0">                                                       
                        <input type="text" formControlName="nombre" class="w-100" placeholder="Nombre del viaje">
                        <div *ngIf="submitted2 && f.nombre.errors" class="text-danger">
                            <div *ngIf="f.nombre.errors.required" style="padding-left: 18px;">Nombre del viaje es requerido.</div>
                        </div>
                    </div>                                      
                </div>                
            </div>
            <div class="col-lg-8 col-xxl-8 z-index--top">
                <div class="form-control p-0">
                    <textarea type="text" formControlName="descripcion" class="w-100 h-auto" placeholder="Breve descripción"></textarea>
                    <div *ngIf="submitted2 && f.descripcion.errors" class="text-danger">
                        <div *ngIf="f.descripcion.errors.required" style="padding-left: 18px; margin-top: -6px;">Descripción es requerido.</div>
                    </div> 
                </div>
            </div>
            <div class="col-lg-4 col-xxl-4 z-index--top d-none d-lg-flex justify-content-md-center justify-content-center">
                                  
            </div>
        </div>
    </form>
</div>

<form [formGroup]="form2" (ngSubmit)="onSubmit2()" class="login z-index-top">
    <div class="container-fluid tour-edit" style="padding-left: 0vw;">
        <div class="row">  
            <!--<div class="align-items-center align-items-md-baseline col-12 col-md-12 d-flex flex-column flex-md-row mb-5 mt-3">-->
            <input *ngIf="!showInput" type="file" id="loadImagen" name="imagenes" style="display:none" multiple
                accept="image/jpeg, image/jpg, image/png" (change)="fileEvent($event)"/>  
            <input *ngIf="showInput" type="file" id="loadImagen" name="imagenes" style="display:none" multiple
                accept="image/jpeg, image/jpg, image/png" (change)="fileEvent($event)"/>
                
            <div *ngIf="!imagenes.length "  class="align-items-center align-items-md-baseline col-12 col-md-12 d-flex flex-column flex-md-row mb-5 mt-3">
                    <div class="d-flex img-tour justify-content-end align-items-center flex-column radius-10" style="float: left">
                        <img src="../assets/images/body/tours/01.jpg" class="h-100" alt="">                        
                    </div>
                    <div class="d-flex img-tour justify-content-end align-items-center flex-column radius-10" style="float: left">
                        <img src="../assets/images/body/tours/01.jpg" class="h-100" alt="">                        
                    </div>
                    <div class="d-flex img-tour justify-content-end align-items-center flex-column radius-10" style="float: left">
                        <img src="../assets/images/body/tours/01.jpg" class="h-100" alt="">                        
                    </div>  
                    <label  for="loadImagen"  class="btn btn-lg btn-primary rounded-pill text-center btn-reservar align-self-center mt-lg-0 mt-4">Cargar imagen</label>
            </div>
            <div *ngIf="imagenes.length" class="align-items-center align-items-md-baseline col-12 col-md-12 d-flex flex-column flex-md-row mb-5 mt-3">
                   <div formArrayName="imagenes" *ngFor="let imagen of imagenes.controls; let i = index;" >
                        <div class="d-flex img-tour justify-content-end align-items-center flex-column radius-10" style="float: left">
                            <div [formGroupName]="i">
                                <img [src]="imagen.controls.url.value" class="w-100" alt="Image Preview">                               
                            </div>
                            <button style="cursor: pointer;"  type="button" class="btn btn-danger position-absolute w-100" (click)="deleteItem(i)">Eliminar</button>
                        
                        </div>
                        <div  [ngClass]="{'text-danger':imagen.controls.toBig.value == true, 'text-normal':imagen.controls.toBig.value == false}">
                            La imagen excede los 2MB                     
                        </div>
                   </div>

                   
                    <label  for="loadImagen"  class="btn btn-lg btn-primary rounded-pill text-center btn-reservar align-self-center mt-lg-0 mt-4">Cargar imagen</label>
            </div>              
            <!--</div>-->
            <div *ngIf="submitted2 && f1.imagenes.errors " class="text-danger">
                <div *ngIf="f1.imagenes.errors.required" style="padding-left: 18px; margin-top: -80px;">Imagen es requerida.</div>
            </div>
            <div class="col-md-6 col-12">
                <h4 class="title-bg mb-3">Información del viaje</h4>
                <div class="form-control p-0" >  
                    <h5 class="mb-2">Destino</h5>                                                     
                    <input type="text" formControlName="destino" class="w-100" placeholder="Destino del viaje">
                    <div *ngIf="submitted2 && f1.destino.errors" class="text-danger">
                        <div *ngIf="f1.destino.errors.required" style="padding-left: 18px;">Destino es requerido.</div>
                    </div>
                </div>
                <div class="form-control p-0">
                    <h5 class="mb-2">Fecha</h5>
                    <div class="d-flex">   
                        <select formControlName="anno" class="documento" style="border-color: #00008B;">
                            <option value="default" selected disabled>Seleccionar Año</option>
                            <option [value]="year">{{year}}</option>
                            <option [value]="year+1">{{year+1}}</option>
                            <option [value]="year+2">{{year+2}}</option>
                            <option [value]="year+3">{{year+3}}</option>
                            <option [value]="year+4">{{year+4}}</option>
                        </select>
                        <select formControlName="mes" class="documento" style="border-color: #00008B; margin-left: 12px;">
                            <option value="default" selected disabled>Seleccionar Mes</option>
                            <option value=1>Enero</option>
                            <option value=2>Febrero</option>
                            <option value=3>Marzo</option>
                            <option value=4>Abril</option>
                            <option value=5>Mayo</option>
                            <option value=6>Junio</option>
                            <option value=7>Julio</option>
                            <option value=8>Agosto</option>
                            <option value=9>Septiembre</option>
                            <option value=10>Octubre</option>
                            <option value=11>Noviembre</option>
                            <option value=12>Diciembre</option>
                        </select>
                        <select formControlName="dia" class="documento" style="border-color: #00008B; margin-left: 12px;">
                            <option value="default" selected disabled>Seleccionar Dia</option>
                            <option *ngFor="let dia of dias" [value]="dia">{{dia}}</option>
                        </select>
                        
                    </div>
                    <div *ngIf="submitted2 && (f1.mes.errors)" class="text-danger">
                        <div *ngIf="f1.mes.errors.confirmedValidator" style="padding-left: 18px;">Dias, mes y año es requerido.</div>                            
                    </div>
                </div>
                <div class="form-control" >
                    <h5 class="mb-2">Salida</h5>
                    <div class="d-flex">
                        <img src="../assets/images/body/tours/salida.svg" class="pe-3" alt="">
                        <input type="text" formControlName="salida" class="w-100" placeholder="Lugar de salida">
                    </div>
                    <div *ngIf="submitted2 && f1.salida.errors" class="text-danger">
                        <div *ngIf="f1.salida.errors.required" style="padding-left: 69px;">Salida es requerida.</div>
                    </div>
                </div>
                <div class="form-control">
                    <h5 class="mb-2">Hotel</h5>
                    <div class="d-flex align-items-center">
                        <img src="../assets/images/body/tours/noches.svg" class="pe-3" alt="">
                        <input type="text" class="noches-admin" formControlName="noches" (keypress)="keypressValue($event)" placeholder="3">
                        <h5 class="mb-0 ps-3">Noches</h5>                                
                    </div>
                    <div *ngIf="submitted2 && f1.noches.errors" class="text-danger">
                        <div *ngIf="f1.noches.errors.required" style="padding-left: 69px;">Noches es requerido.</div>
                    </div>
                </div>
                <div class="form-control">
                    <h5 class="mb-2">Detalle</h5>
                    <div class="d-flex">
                        <input type="text" formControlName="detalles" class="w-100" placeholder="Traslados - Media pensión - Coordinador - Seguro Médico - Tarifa">
                    </div>
                    <div *ngIf="submitted2 && f1.detalles.errors" class="text-danger">
                        <div style="padding-left: 18px;" *ngIf="f1.detalles.errors.required">Detalles es requerido.</div>
                    </div>
                </div>                
            </div>
            <div class="col-md-6 col-12 bg-secondary tours-price mt-3 mt-md-0 ps-0">
                <h4 class="align-items-center bg-white d-flex text-primary title-bg">Precio por adulto <img src="../assets/images/body/tours/price.svg" class="ps-4" alt=""></h4>
                <div class="ps-5 pt-3 pb-4 mb-3">
                    <div *ngFor="let data of tipoHabitacion; let i=index" class="mb-3">
                        <div *ngIf="data.check">
                            <p class="text-white">Habitación {{data.name}}</p>
                            <div class="d-flex align-items-center mt-3">
                                <input type="text" class="border-light text-white" [formControlName]="data.name" currencyMask [options]="{ prefix: '', thousands: '.', decimal: ',' }">
                                <h5 class="mb-0 ps-3 text-white">AR$</h5>
                            </div>
                            <div class="text-danger pt-1" *ngIf="submitted2 && hasError(form2, data.name)" style="padding-left: 18px;">
                                <div *ngIf="requiredError(form2, data.name)">Precio de habitación es requerido.</div>
                                <div *ngIf="precioError(form2, data.name)">Precio de habitación es requerido.</div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-6 d-flex flex-md-row flex-column justify-content-center align-items-center pt-4 ps-0">
            </div>  
            <div class="col-12 col-lg-6 d-flex flex-md-row flex-column justify-content-center justify-content-lg-start align-items-center pb-5 pt-4 ps-0">
                <button style="cursor: pointer;"  type="button" (click)="navItinerario()"  class="text-secondary rounded-pill border border-2 me-md-3 border-secondary nav-link btn-lg btn-outline mb-3 bg" >Cargar itinerario</button>
                <button style="cursor: pointer;"  type="button" (click)="navExcursiones()" class="text-secondary rounded-pill border border-2 me-md-3 border-secondary nav-link btn-lg btn-outline mb-3 bg" >Cargar excursiones</button>
            </div>
        </div>
        <div class="row">
        </div>
    </div>
    <div class="container mt-2">
        <div class="row">
            <div class="col-md-6 col-12 mb-5 mb-md-0">                
                <div class="bg-secondary tours-pasajeros ps-0 pb-5 h-100 pe-2">
                    <h4 class="align-items-center bg-white d-flex text-primary title-bg">Paso 1 - Pasajeros <img src="../assets/images/body/tours/pasajeros.svg" class="ps-4" alt=""></h4>
                    <div class="ps-5 pt-3">                            
                        <h2 class="text-white mb-1">Pasajeros</h2>
                        <p class="text-white">Defina rango de edad</p>                                                 
                    </div>
                    <div class="ps-5 d-flex align-items-md-center flex-column flex-md-row">
                        <h2 class="text-white mb-1 mt-4 mt-md-0 pe-3">Niños</h2>
                        <div class="align-items-center d-flex mb-3 mb-md-0">
                            <p class="text-white mb-0 pe-2">desde</p>
                            <input type="text" formControlName="desde" class="noches-admin border-white text-white me-3 blanco" (keypress)="keypressValue($event)" placeholder="3">                     
                        </div>
                        <div class="align-items-center d-flex mb-3 mb-md-0">
                            <p class="text-white mb-0 pe-2">hasta</p>
                            <input type="text" formControlName="hasta" class="noches-admin border-white text-white blanco" (keypress)="keypressValue($event)" placeholder="12">                   
                        </div>                                                       
                    </div>
                    <div class="ps-5 pt-1 text-danger" *ngIf="submitted2 && f1.desde.errors">
                        <div *ngIf="f1.desde.errors.required">Rango de edad es requerido.</div>                        
                    </div>   
                    <div class="ps-5 pt-1 text-danger" *ngIf="submitted2 && f1.hasta.errors && !f1.desde.errors">
                        <div *ngIf="f1.hasta.errors.required">Rango de edad es requerido.</div> 
                        <div *ngIf="f1.hasta.errors.rangoEdadValidator">Rango de edad no es válido.</div>                       
                    </div>                     
                </div>
            </div>
            <div class="col-md-6 col-12">
                <div class="bg-secondary tours-pasajeros ps-0 pb-5 h-100 pe-2">
                    <h4 class="align-items-center bg-white d-flex text-primary title-bg">Paso 2 - Transporte <img src="../assets/images/body/tours/transporte.svg" class="ps-4" alt=""></h4>
                    <div class="ps-5 pt-3">                            
                        <h2 class="text-white mb-1">Tipo de transporte</h2>
                        <p class="text-white">Defina el tipo de transporte</p>                                             
                    </div>
                    <div class="ps-5">
                        <div class="d-flex">
                            <select formControlName="transporte" (change)="changeTransporte()" class="documento border-white text-white">
                                <option value="default" selected disabled>Seleccionar transporte</option>
                                <option *ngFor="let dato of bdTransporte" class="text-primary" [value]="dato.id" >
                                    {{dato.tipo}}
                                </option>                                    
                            </select>
                            
                        </div>
                        <div class="pt-1 text-danger" *ngIf="submitted2 && f1.transporte.errors" style="padding-left: 18px;">
                            <div *ngIf="f1.transporte.errors.transporteValidator">Transporte es requerido.</div>                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
    <div class="container">        
        <div *ngIf="tipoTransporte==='Bus semi cama'" class="row">
            <app-bus-semicama [asientosInic]="passAsientos" [asientosSelected]="asientosSelected" [bloqueado]="bloqueado"></app-bus-semicama>         
        </div>
        <div *ngIf="tipoTransporte==='Bus mix'" class="row">
            <app-coche-mix [asientosInic]="passAsientos" [asientosSelected]="asientosSelected" [bloqueado]="bloqueado"></app-coche-mix>         
        </div>
        <div *ngIf="tipoTransporte==='Minibus'" class="row">
            <app-minibus [asientosInic]="passAsientos" [asientosSelected]="asientosSelected" [bloqueado]="bloqueado"></app-minibus>         
        </div>
        <div class="pt-1 text-danger" *ngIf="errorAsientos!=='' && !f1.transporte.errors" style="padding-left: 18px;">
            <div>{{errorAsientos}}</div>                            
        </div>
    </div>
    <div class="container mt-5">
        <div class="row">
            <div class="col-md-12 col-12">
                <div class="ps-0 pb-5 pe-2">
                    <h4 class="align-items-center bg-white d-flex text-primary title-bg shadow">Paso 3 - Hotel <img src="../assets/images/body/tours/hotel-title.svg" class="ps-4" alt=""></h4>
                </div>
            </div>
        </div>
    </div>
    <div class="container mt-1">
        <div class="row">
            <!--<div class="col-12 col-md-3 align-items-center align-items-md-baseline d-flex flex-column flex-md-column">
                <input type="file" id="loadImagenHotel" name="imagen" style="display:none"
                accept="image/jpeg, image/jpg, image/png" (change)="fileEvent2($event)"/>
                <div class="d-flex img-tour justify-content-end align-items-center flex-column radius-10">
                  <img *ngIf="!file" src="../assets/images/body/tours/01.jpg" class="h-100" alt="">
                  <img *ngIf="file" [src]="localUrl" class="h-100" alt="" >
            
                </div>
                <div *ngIf="submitted2 && f1.imagen.errors && !file" class="text-danger">
                    <div *ngIf="f1.imagen.errors.required" style="padding-left: 18px; margin-top: -26px;">Imagen es requerida.</div>
                </div>
                <div *ngIf="file && fileToBig" class="text-danger">
                    La imagen excede los 2MB                     
                  </div>

                <label for="loadImagenHotel" class=" ms-0 ms-lg-5 btn btn-lg btn-primary rounded-pill text-center btn-reservar mt-lg-3 mt-1 mb-5">Editar <img src="../assets/images/body/icons/edit.svg" alt=""></label>
            </div>-->
            <div class="col-md-7 col-12 z-index--top">
                <div class="d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" class="me-1" width="25" height="24" viewBox="0 0 18.363 17.512"><path [class.estrella-active]="categoria>=1" d="M10.765,2.083l2.683,5.434,6,.877-4.341,4.228L16.13,18.6l-5.365-2.821L5.4,18.6l1.024-5.973L2.083,8.395l6-.877Z" transform="translate(-1.583 -1.583)" fill="none" stroke="#09f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" class="me-1" width="25" height="24" viewBox="0 0 18.363 17.512"><path [class.estrella-active]="categoria>=2" d="M10.765,2.083l2.683,5.434,6,.877-4.341,4.228L16.13,18.6l-5.365-2.821L5.4,18.6l1.024-5.973L2.083,8.395l6-.877Z" transform="translate(-1.583 -1.583)" fill="none" stroke="#09f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" class="me-1" width="25" height="24" viewBox="0 0 18.363 17.512"><path [class.estrella-active]="categoria>=3" d="M10.765,2.083l2.683,5.434,6,.877-4.341,4.228L16.13,18.6l-5.365-2.821L5.4,18.6l1.024-5.973L2.083,8.395l6-.877Z" transform="translate(-1.583 -1.583)" fill="none" stroke="#09f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" class="me-1" width="25" height="24" viewBox="0 0 18.363 17.512"><path [class.estrella-active]="categoria>=4" d="M10.765,2.083l2.683,5.434,6,.877-4.341,4.228L16.13,18.6l-5.365-2.821L5.4,18.6l1.024-5.973L2.083,8.395l6-.877Z" transform="translate(-1.583 -1.583)" fill="none" stroke="#09f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" class="me-1" width="25" height="24" viewBox="0 0 18.363 17.512"><path [class.estrella-active]="categoria>=5" d="M10.765,2.083l2.683,5.434,6,.877-4.341,4.228L16.13,18.6l-5.365-2.821L5.4,18.6l1.024-5.973L2.083,8.395l6-.877Z" transform="translate(-1.583 -1.583)" fill="none" stroke="#09f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/></svg>

                    <a style="cursor: pointer;"  (click)="openCategoria()" class="ms-5 btn btn-md btn-primary rounded-pill text-center btn-reservar ">Editar <img src="../assets/images/body/icons/edit.svg" alt=""></a>
                </div>
                <div class="form-control pt-5">
                    <input type="text" formControlName="hotel" class="w-100" placeholder="Nombre del hotel">
                </div>
                <div *ngIf="submitted2 && f1.hotel.errors" class="text-danger">
                    <div *ngIf="f1.hotel.errors.required" style="padding-left: 18px; margin-top: -18px;">Nombre del hotel es requerido.</div>
                </div>
                <!-- AMBOS RADIOS SON SELECCIONES MULTIPLES -->
                <p class="mt-4">Seleccione tipo de habitación</p>
                <div class="d-flex align-items-center">
                    <div  *ngFor="let data of tipoHabitacion; let i=index">
                        <input  type="checkbox" [value]="data.value" [checked]="data.check" (change)="onCheckboxChange($event)" />
                        <span class="mb-0 ps-2 pe-4">{{data.name}}</span>
                    </div>                            
                </div>
                <div *ngIf="submitted2 && f1.checkHabitacion.errors" class="text-danger">
                    <div *ngIf="f1.checkHabitacion.errors.required">Tipo de habitación es requerido.</div>
                </div>
                <p class="mt-4">Seleccione tipo de cama</p>
                <div class="d-flex align-items-center">
                    <div  *ngFor="let data of tipoCama; let i=index">
                        <input  type="checkbox" [value]="data.value" checked (change)="onCheckboxChange1($event)" />
                        <span class="mb-0 ps-2 pe-4">{{data.name}}</span>
                    </div> 
                </div>
                <div *ngIf="submitted2 && f1.checkCama.errors" class="text-danger">
                    <div *ngIf="f1.checkCama.errors.required">Tipo de cama es requerido.</div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 text-center z-index--top" style="margin-top: 50px;">
        <button  type="submit" class="btn btn-lg rounded-pill btn-primary text-white text-center align-self-center z-index--top ">Guardar Cambios</button> 
    </div>
</form>


  
